<!--
 * @Github: https://github.com/wangjiawei2019
 * @Date: 2019-06-20 18:10:14
 * @LastEditors: linfangxing 2948276710@qq.com
 * @LastEditTime: 2023-06-05 18:10:55
 -->
<template>
  <div class="navtitle">
    当前位置：
    <span @click="goHome">首页</span>
    <span v-if="navTitle && navSubTitle">&nbsp;></span>
    <span v-if="navTitle && navSubTitle" @click="refresh">&nbsp;{{navTitle}}</span>
    <span>&nbsp;></span>
    <span @click="goBack">&nbsp;{{navSubTitle ? navSubTitle : navTitle}}</span>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    pathOne() {
      return this.$route.path.split("/")[1];
    },
    pathTwo() {
      return this.$route.path.split("/")[2];
    },
    navTitle() {
      const title = {
        about: "关于我们",
        news: "新闻资讯",
        search: "站内搜索",
        old_age_education: "老年教育",
        lesson: "课程教材",
        teacher: "讲师精选",
        school: "校园活动",
        student: "学员风采",
        policy_building: "党政建设",
        special_report: "专题报导",
        information_open: "信息公开",
        online_service: "数字化校园",
        detail: "文章详情",
        info: {
          1: "",
          2: "关于我们",
          other: "新闻资讯"
        }
      };
      if (this.pathOne === "info") {
        return Object.keys(title.info).includes(this.pathTwo)
          ? title.info[this.pathTwo]
          : title.info.other;
      } else {
        return title[this.pathOne];
      }
    },
    navSubTitle() {
      return this.$store.getters["Home/getSubTitle"](
        this.pathOne,
        this.pathTwo
      );
    }
  },
  methods: {
    goHome() {
      this.$router.push({ path: "/" });
    },
    refresh() {
      const menuList = this.$store.state.Home.menuList;
      const pathMap = {};
      menuList.map(i => {
        pathMap[i.key] = `/${i.key}/${i.subNav[0].id}`;
      });
      if (pathMap.hasOwnProperty(`${this.pathOne}`)) {
        this.$router.push({
          path: pathMap[this.pathOne]
        });
      }
      if (this.pathOne === "info") {
        // info 里面的第二级路由 "1" -> "首页轮播" "2" -> "组织机构" "3" -> "头条"
        if (this.pathTwo === "2") {
          this.$router.push({
            path: pathMap.about
          });
        }
        if (this.pathTwo === "3") {
          this.$router.push({
            path: pathMap.news
          });
        }
      }
    },
    goBack() {
      if (this.pathOne === "info") {
        if (this.pathTwo === "2") {
          this.$router.push({
            path: "/about/2"
          });
        }
        if (this.pathTwo === "3") {
          this.$router.push({
            path: "/news/0"
          });
        }
      } else {
        this.$router.push({
          path: `/${this.pathOne}/${this.pathTwo}`
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
%mgto {
  margin: 0 auto;
}

@mixin displayflex($row, $column, $direction, $wrap) {
  display: flex;

  @if $direction==column {
    flex-direction: column;
  } @else {
    flex-direction: row;
  }

  @if $wrap==wrap {
    flex-wrap: wrap;
  } @else {
    flex-wrap: nowrap;
  }

  justify-content: $row;
  align-items: $column;
}

.navtitle {
  width: 1200px;
  height: 66px;
  @include displayflex(flex-start, center, row, nowrap);
  font-family: "PingFangSC-Regular";
  color: #888888;
  font-size: 18px;
  @extend %mgto;
  span:hover {
    cursor: pointer !important;
    color: #c52e0f;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ActNav.vue